import { render, staticRenderFns } from "./TrademarkOppositionOwnerList.vue?vue&type=template&id=ce7fe342&"
import script from "./TrademarkOppositionOwnerList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionOwnerList.vue?vue&type=style&index=0&id=ce7fe342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports